module.exports = __webpack_public_path__ + "media/images/icons/media-play-50fc942a7674d552102cfd85b275a649.svg";